/**
 * 课程评价接口
 */
import axios from '../axios';

export const getSchoolList = () => {
  return axios({
    url: '/con/u/course/comment/getSchoolList',
    method: 'GET'
  })
}

export const getCourseEvaluationList = (data) => {
  return axios({
    url: '/con/u/course/comment/getUserCourseCommentList',
    method: 'GET',
    data
  })
}

export const getCourseEvaluationDetailInfo = (data) => {
  return axios({
    url: '/con/u/course/comment/getUserCourseCommentDetail',
    method: 'GET',
    data
  })
}


// WEBPACK FOOTER //
// ./src/http/moudules/curriculumEvaluationManagement.js